<template>


  <div v-show="isVisible" id="calc-app-container" class="col-12 col-md-6 col-lg-8 col-xl-4 calc   d-flex align-items-center  " :class="{
               
                'my-3 my-md-5 my-lg-2 my-xl-5': !isLocal,
                'local-container': isLocal
            }">



    <div id="calc-app" class="wrapper calc " data-app>

      <div class="row params dark-bg d-flex justify-content-between">

        <div class="col-auto me-auto amount-label d-flex align-items-end">Wybierz kwotę</div>
        <div class="col-auto amount text-end" v-cloak>
          {{loanAmount}} <span class="currency">zł</span>
        </div>


        <v-slider class="col-12 amount-slider mt-1 mb-3"
                  v-model="loanAmount"
                  :tick-labels="sliderLabels"
                  :min="minAmount"
                  :max="maxAmount"
                  :step="step"
                  ticks="always"
                  tick-size="4"
                  @input="onCalcSlide"
                  @end="onSlideEnd"></v-slider>



<!--         <div class="col-auto me-auto amount-label d-flex align-items-end">Wybierz okres</div>
        <div class="col-auto amount text-end" v-cloak>
          {{loanTenor}} <span class="currency">mc</span>
        </div>

        <v-slider class="col-12 amount-slider mt-1 mb-3"
                  v-model="loanTenor"
              
                  :min="minTenor"
                  :max="maxTenor"
                 
                  :tick-labels="tenorLabels"
                  :step="tenorStep"

                  ticks="always"
                  tick-size="4"
                  @input="onCalcSlide"
                  @end="onSlideEnd"></v-slider> -->


        <div class="col-12 loan-period text-end">Okres 30 dni</div>




        <div class="col-12 cta my-4 text-center">
          <div class="mb-2">


            <a v-if="loanAmount <= firstTreshold && !isLocal" class="cta-btn-xl btn btn-outline-primary btn-lg me-2" href="javascript:void(0);" @click="goApplicate">Weź pożyczkę</a>
<!-- 
            <a v-if="loanAmount <= firstTreshold && isLocal || isLoggedIn" class="cta-btn-xl btn btn-outline-primary btn-lg me-2" href="javascript:void(0);" @click="goApplicate">Zatwierdź</a>

 -->


<!--  
            <a v-if="loanAmount > firstTreshold && !isLoggedIn" class="cta-btn-xl btn btn-outline-primary btn-lg me-2" href="javascript:void(0);" @click="goLogin">Zaloguj</a>

 -->
          </div>
          <div><a class="plain" href="#" @click="showInfoForm">Formularz informacyjny</a></div>
        </div>
      </div>
      <div class="row details">



<!--         <div class="col-12 tabs d-flex">

          <div class="tab flex-fill " :class="{
               'active' : loanAmount <= firstTreshold

                            }"><a href="#">Pierwsza pożyczka</a></div>


          <div class="tab flex-fill" :class="{
               'active' : loanAmount>
            firstTreshold

            }"><a href="#">Kolejna pożyczka</a>
          </div>

        </div>
 -->



        <div class="col-12 tab-content">

          <div class="row ">
            <div class="col-sm-12 loan-details py-4 px-4">
              <div class="row">
                <div class="col col-auto me-auto">
                  Kwota:
                </div>
                <div class="col col-auto">
                  {{loanAmount}} zł
                </div>
              </div>
<!--               <div class="row">
                    <div class="col col-auto me-auto">
                        Miesięczna rata:
                    </div>
                    <div class="col col-auto">
                      {{installmentAmount}} zł
                    </div>
              </div> -->
              <div class="row">
                <div class="col col-auto me-auto">
                  Okres:
                </div>
                <div class="col col-auto">
                  {{loanTenor}} {{ tenorSign == 'd' ? 'dni' : 'mc' }}
                </div>
              </div>
              <div class="row">
                <div class="col col-auto me-auto">
                  Data spłaty:
                </div>
                <div class="col col-auto">
                  {{finishDate}}
                </div>
              </div>
              <div class="row">
                <div class="col col-auto me-auto">
                  Prowizja:
                </div>
                <div class="col col-auto">
                  {{service}} zł
                </div>
              </div>
              <div class="row">
                <div class="col col-auto me-auto">
                  Oprocentowanie:
                </div>
                <div class="col col-auto">
                  {{interest}} zł
                </div>
              </div>
              <div class="row">
                <div class="col col-auto me-auto">
                  RRSO:
                </div>
                <div class="col col-auto">
                  {{rrso}} %
                </div>
              </div>
              <div class="row summary">
                <div class="col col-auto me-auto">
                  Razem:
                </div>
                <div class="col col-auto">
                  {{total}} zł
                </div>
              </div>



              <div class="row sample">
                


Przykład reprezentatywny: {{getConf('loan_sample')}}




              </div>

              
            </div>
          </div>
        </div>


      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade"  ref="modal">
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header container dark-bg">
            <div class="col-auto me-auto ">
              <h3>Formularz</h3>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" v-html="formText">
          </div>

          <div class="modal-footer justify-content-center">

            <button type="button" class="btn btn-lg btn-success" data-bs-dismiss="modal"> Zamknij </button>

            <!--
             <b-col lg="4" class="pb-2"><b-button type="button" size="lg" class="btn btn-secondary " data-bs-dismiss="modal">Zamknij</b-button></b-col> -->
          </div>

        </div>
      </div>
    </div>
  </div>



</template>

<script>
  import { info_form } from './modal_details.js';



    import __prm from './calc_params.json';


   

    export default {
        name: "CalcSlider",

        computed: {
          installmentAmount(){

            return this.total; // (this.total / this.loanTenor).toFixed(2);
          },


          isLocal(){

            return !this.endpoint.length;
          }
            

        },


        components: {
          info_form
        },

        data(){
          return {
              params: [],

                isVisible: true,

                isLoggedIn: false,

                // loanAmount/loanTenor/tenorSign oraz total/interest/commission/
                // service/insurance/rrso/dailyInterest/finishDate pochodza teraz z
                // mixinu common.js (computed -> proxy do loanStore). NIE deklarujemy
                // ich lokalnie, bo kolidowaloby z computed (Vue warn + zerwana
                // propagacja przez store). Wartosci poczatkowe bierze loanStore z
                // configu (default_amount/default_tenor/tenor_sign).

                minTenor: 30,
                maxTenor: 30,
                tenorStep: 1,
                tenorLabels: ['12', '18', '24'],

                minAmount: 1000,
                maxAmount: 3000,
                step: 100,

                firstTreshold: 15000,

                labelValues: [1000,  3000],

                sliderLabels: [],

                formText: '',


                modal: null
            }
        },


        props: {


            endpoint: {
                type: String,
                default: 'http://localhost:8080'
            }



        },

      

        methods: {


            onCalcSlide(){

              this.setValues(this.loanAmount, this.loanTenor, this.tenorSign);
            },

            onSlideEnd(){

              // wartosci kalkulatora propaguja sie automatycznie przez loanStore
              // (mixin common.js computed) - bus 'values_set'/echoValues juz niepotrzebny
            },



            setValues(v, t='30', s='d'){         


                if ( this.params.hasOwnProperty(String(t+s)) && this.params[t+s].hasOwnProperty(String(v)) ) {

                    let dat = this.params[t+s][v],
                        now = new Date(),
                        newDate = s == 'm' ? new Date(now.setMonth(now.getMonth() + t)) : new Date(Date.now() + t * 24*60*60*1000),
                        iso = newDate.toISOString();



                    this.loanAmount = v;
                    this.loanTenor = t;
                    this.tenorSign = s;




                    this.total = ( dat[0]  ).toFixed(2);



                    this.interest = dat[2];
                    this.service = dat[3];
                    this.commission = dat[4];
                    this.insurance = dat[5];
                    this.rrso = dat[6];


                    this.finishDate = iso.split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');


                    this.dailyInterest = parseInt(this.commission) / 30;


                  let patt, rep;

                  this.formText = [
                    ['{m%POZYCZKA.KAPITAL}', this.loanAmount],
                    ['{m%POZYCZKA.CALKOWITA_KWOTA_DO_SPLATY}', this.total],

                    ['{POZYCZKA.OPROCENTOWANIE_STOPA}', this.getConf('nbp_interest_rate')],
                    ['{m%POZYCZKA.OPROCENTOWANIE_STOPA}', this.getConf('nbp_interest_rate')],
                    ['{POZYCZKA.STOPA_NBP}', this.getConf('nbp_penalty_rate')],
                    ['{m%POZYCZKA.STOPA_NBP}', this.getConf('nbp_penalty_rate')],
                    ['{POZYCZKA.PRZYKLAD}', this.getConf('loan_sample')],
                    ['{POZYCZKA.PRZYKLAD_KWOTA}', this.getConf('sample_amount')],
                    ['{POZYCZKA.PRZYKLAD_PROWIZJA}', this.getConf('sample_fee')],
                    ['{POZYCZKA.PRZYKLAD_ODSETKI}', this.getConf('sample_interest')],
                    ['{POZYCZKA.PRZYKLAD_OBSLUGA}', this.getConf('sample_service')],
                    ['{POZYCZKA.PRZYKLAD_KOSZT}', this.getConf('sample_cost')],
                    ['{POZYCZKA.PRZYKLAD_RRSO}', this.getConf('sample_rrso')],
                    ['{POZYCZKA.PRZYKLAD_DATA}', this.getConf('sample_valid_from')],
                    ['{POZYCZKA.PRZYKLAD_CALKOWITA_KWOTA}', this.getConf('sample_total')],


                    ['{POZYCZKA.RRSO}', this.rrso+' '],
                    ['{POZYCZKA.DATA_SPLATY}r.', this.finishDate+'r.'],
                    ['{POZYCZKA.OPLATA_POCZATKOWA}', this.service],
                    ['{m%POZYCZKA.OPLATA_POCZATKOWA}', this.service],
                    ['{POZYCZKA.OPROCENTOWANIE}', this.interest],
                    ['{m%POZYCZKA.OPROCENTOWANIE}', this.interest],
                    ['{POZYCZKA.ODSETKI_DZIENNE}', parseFloat(this.dailyInterest).toFixed(2)],
                    ['{POZYCZKA.LICZBA_RAT}', this.loanTenor],
                    ['{m%POZYCZKA.KWOTA_RATY}', (this.total/this.loanTenor).toFixed(2)],
                    ['{m%POZYCZKA.OPLATA_POCZATKOWA}', this.commission],
                    ['{m%POZYCZKA.OPLATA_ZA_OBSLUGE}', this.service]
                  ]
                  .reduce((acc, itm) => {

                    return acc.replaceAll(new RegExp(itm[0], 'g'), itm[1]);
                  }, info_form);

                }

            },


            goApplicate(){

                if (this.isLocal) {

                  // wartosci sa juz w loanStore; powiadom formularz o zatwierdzeniu kalkulacji
                  this.echo('calc_edit_done');
                }
                else {
                  window.location = this.endpoint + '?amount=' + this.loanAmount;
                }
            },


            goLogin(){

              if (this.isLocal && this.hasOwnProperty('echo')) {

                this.echo('login_dialog');
              }
              else {

                window.location = this.endpoint + '?login';
              }
            },

            showInfoForm(){

              this.modal.show();
            }

         
        },     





        created() {




            let now = new Date(), 

                newDate = this.tenorSign == 'm' ? new Date(now.setMonth(now.getMonth() + this.loanTenor)) : new Date(Date.now() + this.loanTenor * 24*60*60*1000), 
                iso = newDate.toISOString();


            this.finishDate = iso.split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');



            this.isLoggedIn = !!localStorage.getItem('user');


            if (this.isLocal) {


              this.listen('logged_in', () => {
                this.isLoggedIn = true;
              });

              this.listen('logged_out', () => {
                this.isLoggedIn = false;
              });
            }



            if (typeof __prm == 'object') {
                let t, i, o;
                for (t in __prm) {
                    if (__prm.hasOwnProperty(t)) {
                        for (i in __prm[t]) {
                            if (__prm[t].hasOwnProperty(i)) {
                                o = String(i).split('_');

                                // init
                                this.params[o[1]] = this.params[o[1]] || [];

                                this.params[o[1]][ '' + String(o[0].replace('-', '.') * 100) ] = __prm[t][i];
                            }
                        }
                    }
                }


                // initial
                this.setValues(this.loanAmount, this.loanTenor, this.tenorSign);


                this.sliderLabels = this.labelValues.reduce((accu, itm) => {

                  if (!accu){
                    return [itm];
                  }

                  return accu.concat( ...Array( (Math.abs(accu[accu.length-1] - itm) / this.step) - 1 ) ).concat( itm );
                }, 0);


            }

          
        },

        mounted(){



          this.modal = new bootstrap.Modal(this.$refs['modal']);





        }
    }
</script>


<style scoped>
  .modal-dialog {
    max-width: 900px;
  }


  .modal-header {
    display: flex;
  }

  .modal-title {
    color: #fefefe;
  }

  .modal-body {
    overflow-y: auto;
  }


  .local-container {

    padding-top: 0;
  }
</style>


// WEBPACK FOOTER //
// src/CalcSlider.vue